export const environment = {
  production: true,
  apiUrl: 'https://site.vaunt.ro',
  baseApiPath: 'v1/site',
  agency_uuid: 'a8a55e28-9f3f-4d34-a9ba-0d625656f861',
  sentry_public_dsn: 'https://a23296e28abd4019bb288d7acef1ba8a@sentry.aesthetic-works.net/49',
  re_captcha_site_key: '6LcuzNcUAAAAAJqGjGlX89GcwIgkyEYGB6WbudNE',
  re_captcha_version: 'v2_invisible',
  analytics_tracking_id: 'GTM-PVRM2F8',
  facebook_pixel_id: '429585563175452',
  release: 'APP_RELEASE',
  router_link_has_locale: false,
  ads_tracking_id: 'G-3Y0FN1P9ZF',
  ads_phone_conversion_label: null,
  default_locale: 'ro'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts